var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"righthead"},[_c('div',{staticClass:"userinfo",on:{"click":_vm.showxiala}},[_vm._v(_vm._s(_vm.login_id))]),_vm._v(" "),(_vm.showbtn)?_c('div',{staticClass:"logout",on:{"click":_vm.user_logout}},[_vm._v("退出登录")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c53ad980","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/xxxvue/Headerlg.vue
// module id = null
// module chunks = 